import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';
import { formatToDecimal, formatToFractional } from '../conversions';

export const MM_PER_INCH = 25.4;

// '40"' / '39 3/8"' -> '1016' / '1000'
export const inchToMm = (inchValue) => {
    const inches = parseFloat(formatToDecimal(inchValue));
    return inches > 0 ? String(Math.round(inches * MM_PER_INCH)) : '';
};

// 1000 -> '39 3/8"' (rounded to the nearest 1/16 so 1015 mm gives 40", not 39 15/16")
export const mmToInch = (mmValue) => {
    const mm = parseFloat(mmValue);
    if (!(mm > 0)) return '';
    return formatToFractional(Math.round((mm / MM_PER_INCH) * 16) / 16);
};

// Metric companion to the inch size fields; minValue/maxValue are in inches.
const SizeMm = ({ value, onChange, id, label, minValue, maxValue, disabled = false }) => {
    const [mmValue, setMmValue] = useState(value || '');

    useEffect(() => {
        setMmValue(value || '');
    }, [value]);

    const handleChange = (e) => {
        const typed = e.target.value.replace(/[^\d.]/g, '');
        setMmValue(typed);
        onChange(typed);
    };

    const handleBlur = () => {
        const mm = parseFloat(mmValue);
        if (mm > 0) {
            const rounded = String(Math.round(mm));
            setMmValue(rounded);
            onChange(rounded);
        }
    };

    const mm = parseFloat(mmValue);
    const minMm = minValue ? Math.round(minValue * MM_PER_INCH) : null;
    const maxMm = maxValue ? Math.round(maxValue * MM_PER_INCH) : null;
    const error = mm && minMm && maxMm && (mm < minMm || mm > maxMm)
        ? `Must be between ${minMm} and ${maxMm} mm`
        : '';

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor={id}>{label}</label>
            <input
                disabled={disabled}
                id={id}
                inputMode="numeric"
                value={mmValue}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            {error && <p className="error">{error}</p>}
        </div>
    );
};

export default SizeMm;
